module.exports = __webpack_public_path__ + "img/how-to-watch.b8c59aa6.jpg";